export const STRIPE_TEST_CARDS_URL = 'https://checkoutpage.com/tools/stripe-test-cards';

// Only cards that succeed. The API finalizes a test-mode order without ever
// calling Stripe, so a decline or 3DS card would complete exactly like Visa.
// Offer those again once test mode confirms a real test-mode payment.
export const testCardGroups = [
  {
    label: 'Succeeds',
    cards: [
      { id: 'visa', name: 'Visa', number: '4242 4242 4242 4242' },
      { id: 'mastercard', name: 'Mastercard', number: '5555 5555 5555 4444' },
      // Amex security codes are four digits; a three digit one is rejected
      // before the card is ever authorised.
      { id: 'amex', name: 'American Express', number: '3782 822463 10005', cvc: '1234' },
    ],
  },
];

const DEFAULT_EXPIRY = '12/28';
const DEFAULT_CVC = '123';

export const testCards = testCardGroups.flatMap(group =>
  group.cards.map(card => ({
    expiry: DEFAULT_EXPIRY,
    cvc: DEFAULT_CVC,
    outcome: group.label,
    ...card,
  })),
);

export const defaultTestCard = testCards[0];

export function findTestCard(id) {
  return testCards.find(card => card.id === id) || defaultTestCard;
}
